<template>
  <CurrencySelectorCard
    :currency-code="currency?.currencyCode ?? ''"
    :flag-country-code="currency?.flagCountryCode ?? ''"
  />
</template>

<script lang="ts" setup>
// COMPONENTS
import CurrencySelectorCard from '@/shared/common/components/CurrencySelectorCard/index.vue';

// TYPES
import type { CurrencyWalletType } from '@/types/CurrencyWalletType';

defineProps<{
  currency?: CurrencyWalletType;
}>();
</script>
